import { PropsWithChildren } from 'react';

import { IconsByState, Variants } from '@/components/atoms/Icons/IconsByState';

type StatusIconProps = { status: Variants };

export const StatusIcon = ({ status, children }: PropsWithChildren<StatusIconProps>) => {
  return (
    <span className="relative [&>:first-child]:absolute [&>:first-child]:bottom-2 [&>:first-child]:left-2 [&>:first-child]:max-h-3 [&>:first-child]:max-w-3">
      {IconsByState[status]}
      {children}
    </span>
  );
};
